/* MAQUETA VISUAL (datos de ejemplo) — solo para que la dueña elija el diseño.
   No consulta la API. Se borra o se convierte en componente real según su elección. */
import { ArrowRight, Target, TrendingUp, Clock, Users,
  Sparkles, Wallet, AlertTriangle } from "lucide-react";

const Card = ({ children, className = "" }) => (
  <div className={`bg-white border border-slate-200 rounded-2xl ${className}`}>{children}</div>
);

const Etiqueta = ({ children }) => (
  <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">{children}</div>
);

/* ─────────── OPCIÓN A · Tarjeta compacta para el Resumen ─────────── */
const OpcionA = () => (
  <Card className="p-5" >
    <div className="flex items-start justify-between">
      <div>
        <div className="font-display text-lg font-bold tracking-tight text-slate-900">Efectividad de leads</div>
        <div className="text-xs text-slate-500 mt-0.5">Septiembre 2026 · Español</div>
      </div>
      <span className="h-8 w-8 rounded-lg grid place-items-center bg-orange-50 text-orange-600">
        <Target className="h-4 w-4" />
      </span>
    </div>

    <div className="mt-5 flex items-end gap-3">
      <div className="text-[46px] font-extrabold leading-none tracking-[-0.04em] tabular-nums text-slate-900">62<span className="text-2xl text-slate-400">%</span></div>
      <div className="pb-1.5">
        <div className="text-[13px] font-semibold text-slate-700">tasa de cierre real</div>
        <div className="text-[11.5px] text-slate-500"><span className="font-bold text-emerald-600">▲ 9 pts</span> vs agosto</div>
      </div>
    </div>
    <div className="mt-1 text-[11px] text-slate-400">ganados ÷ (ganados + perdidos) — no castiga a los que siguen abiertos</div>

    <div className="mt-4 grid grid-cols-3 gap-2">
      {[
        { n: 13, l: "Ganados", cls: "bg-emerald-50 border-emerald-200", txt: "text-emerald-700" },
        { n: 8, l: "Perdidos", cls: "bg-rose-50 border-rose-200", txt: "text-rose-700" },
        { n: 21, l: "En juego", cls: "bg-amber-50 border-amber-200", txt: "text-amber-700" },
      ].map((x) => (
        <div key={x.l} className={`rounded-xl border px-3 py-2.5 ${x.cls}`}>
          <div className={`text-2xl font-extrabold tabular-nums leading-none ${x.txt}`}>{x.n}</div>
          <div className={`text-[11px] font-medium mt-1 ${x.txt} opacity-80`}>{x.l}</div>
        </div>
      ))}
    </div>

    <div className="mt-4 pt-4 border-t border-slate-100 space-y-2.5">
      <div className="flex items-center gap-2 text-[12.5px]">
        <AlertTriangle className="h-3.5 w-3.5 text-amber-600 shrink-0" />
        <span className="text-slate-700"><b>7 leads</b> llevan más de 5 días sin movimiento</span>
        <ArrowRight className="h-3 w-3 text-slate-400 ml-auto" />
      </div>
      <div className="flex items-center gap-2 text-[12.5px]">
        <Clock className="h-3.5 w-3.5 text-blue-600 shrink-0" />
        <span className="text-slate-700">Primera respuesta: <b>4 h 20 m</b> · cierre en <b>11 días</b></span>
      </div>
    </div>
  </Card>
);

/* ─────────── OPCIÓN B · Embudo con cuello de botella ─────────── */
const pasos = [
  { l: "Nuevos", n: 42, c: "#334155" },
  { l: "Contactados", n: 38, c: "#0ea5e9" },
  { l: "Entrevista", n: 24, c: "#6366f1" },
  { l: "Info enviada", n: 19, c: "#a855f7" },
  { l: "Clase intro", n: 15, c: "#f59e0b" },
  { l: "Matriculados", n: 13, c: "#10b981" },
];
const OpcionB = () => {
  const max = pasos[0].n;
  const caidas = pasos.map((p, i) => (i === 0 ? 0 : Math.round((1 - p.n / pasos[i - 1].n) * 100)));
  const peor = caidas.indexOf(Math.max(...caidas));
  return (
    <Card className="p-5">
      <div className="flex items-start justify-between">
        <div>
          <div className="font-display text-lg font-bold tracking-tight">Embudo de conversión</div>
          <div className="text-xs text-slate-500 mt-0.5">Últimos 90 días · Español · 42 leads</div>
        </div>
        <span className="h-8 w-8 rounded-lg grid place-items-center bg-indigo-50 text-indigo-600">
          <TrendingUp className="h-4 w-4" />
        </span>
      </div>
      <div className="mt-5 space-y-2.5">
        {pasos.map((p, i) => (
          <div key={p.l}>
            <div className="flex items-center gap-3">
              <div className="w-28 text-[12.5px] text-slate-600 shrink-0">{p.l}</div>
              <div className="flex-1 h-8 rounded-lg bg-slate-50 overflow-hidden relative">
                <div className="h-full rounded-lg flex items-center px-2.5"
                     style={{ width: `${(p.n / max) * 100}%`, background: p.c }}>
                  <span className="text-white text-[12.5px] font-bold tabular-nums">{p.n}</span>
                </div>
              </div>
              <div className="w-24 text-right shrink-0">
                {i > 0 && (
                  <span className={`text-[11.5px] font-semibold ${i === peor ? "text-rose-600" : "text-slate-400"}`}>
                    −{caidas[i]}%
                  </span>
                )}
              </div>
            </div>
            {i === peor && (
              <div className="ml-28 mt-1 mb-1 inline-flex items-center gap-1.5 text-[11px] font-semibold
                              text-rose-700 bg-rose-50 border border-rose-200 rounded-full px-2 py-0.5">
                <AlertTriangle className="h-3 w-3" /> Aquí se pierde más gente
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-slate-100 flex items-center gap-2 text-[12.5px] text-slate-700">
        <Sparkles className="h-3.5 w-3.5 text-amber-500" />
        De cada 100 leads, <b className="mx-1">31</b> terminan matriculados
      </div>
    </Card>
  );
};

/* ─────────── OPCIÓN C · Clase introductoria como predictor ─────────── */
const OpcionC = () => (
  <Card className="p-5">
    <div className="flex items-start justify-between">
      <div>
        <div className="font-display text-lg font-bold tracking-tight">La clase introductoria vende</div>
        <div className="text-xs text-slate-500 mt-0.5">Cierre según lo que hizo el lead</div>
      </div>
      <span className="h-8 w-8 rounded-lg grid place-items-center bg-amber-50 text-amber-600">
        <Users className="h-4 w-4" />
      </span>
    </div>
    <div className="mt-5 space-y-4">
      {[
        { l: "Asistió a la clase intro", v: 78, n: "14 de 18", c: "#10b981" },
        { l: "Nunca tomó clase intro", v: 24, n: "6 de 25", c: "#64748b" },
        { l: "Agendó y no llegó", v: 9, n: "1 de 11", c: "#f43f5e" },
      ].map((x) => (
        <div key={x.l}>
          <div className="flex items-baseline justify-between">
            <span className="text-[12.5px] text-slate-700">{x.l}</span>
            <span className="text-[13px] font-extrabold tabular-nums" style={{ color: x.c }}>{x.v}%</span>
          </div>
          <div className="mt-1.5 h-2.5 rounded-full bg-slate-100 overflow-hidden">
            <div className="h-full rounded-full" style={{ width: `${x.v}%`, background: x.c }} />
          </div>
          <div className="text-[11px] text-slate-400 mt-1">{x.n} matriculados</div>
        </div>
      ))}
    </div>
    <div className="mt-4 pt-4 border-t border-slate-100 text-[12.5px] text-slate-700">
      Quien asiste a la intro cierra <b>3,2 veces más</b>. Llenar clases intro es la palanca.
    </div>
  </Card>
);

/* ─────────── OPCIÓN D · Canal, dinero y motivos de pérdida ─────────── */
const OpcionD = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    <Card className="p-5">
      <Etiqueta>Cierre por canal</Etiqueta>
      <div className="mt-3.5 space-y-3">
        {[
          { l: "Referidos", leads: 9, cierre: 67 },
          { l: "WhatsApp", leads: 17, cierre: 41 },
          { l: "Formulario web", leads: 21, cierre: 29 },
          { l: "Instagram", leads: 14, cierre: 14 },
        ].map((x) => (
          <div key={x.l} className="flex items-center gap-3">
            <div className="w-28 text-[12.5px] text-slate-600 shrink-0">{x.l}</div>
            <div className="flex-1 h-2.5 rounded-full bg-slate-100 overflow-hidden">
              <div className="h-full rounded-full bg-slate-800" style={{ width: `${x.cierre}%` }} />
            </div>
            <div className="w-16 text-right text-[12px] font-bold tabular-nums text-slate-800">{x.cierre}%</div>
          </div>
        ))}
      </div>
      <div className="mt-4 text-[11.5px] text-slate-500">
        Instagram trae volumen pero cierra poco. Los referidos son oro.
      </div>
    </Card>

    <Card className="p-5">
      <Etiqueta>En dinero</Etiqueta>
      <div className="mt-3.5">
        <div className="text-[32px] font-extrabold tracking-[-0.03em] leading-none tabular-nums text-emerald-600">$3.900</div>
        <div className="text-[12px] text-slate-500 mt-1">ingresado por leads cerrados este mes</div>
      </div>
      <div className="mt-4 pt-4 border-t border-slate-100">
        <div className="text-[28px] font-extrabold tracking-[-0.03em] leading-none tabular-nums text-amber-600">$6.300</div>
        <div className="text-[12px] text-slate-500 mt-1">en juego · 21 leads abiertos × ticket promedio</div>
      </div>
      <div className="mt-4 flex items-center gap-1.5 text-[11.5px] text-slate-500">
        <Wallet className="h-3.5 w-3.5" /> Ticket promedio de matrícula: $300
      </div>
    </Card>

    <Card className="p-5">
      <Etiqueta>Por qué los perdemos</Etiqueta>
      <div className="mt-3.5 space-y-2.5">
        {[
          { l: "No volvió a responder", n: 4 },
          { l: "Precio", n: 2 },
          { l: "Horarios no le calzan", n: 1 },
          { l: "Solo preguntaba", n: 1 },
        ].map((x) => (
          <div key={x.l} className="flex items-center justify-between text-[12.5px]">
            <span className="text-slate-700">{x.l}</span>
            <span className="font-bold tabular-nums text-slate-900">{x.n}</span>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-slate-100 text-[11.5px] text-slate-500">
        Requiere pedir el motivo al descartar un lead (hoy no se guarda).
      </div>
    </Card>
  </div>
);

export default function LeadsEffectivenessPreview() {
  return (
    <div className="space-y-10 pb-16" data-testid="leads-effectiveness-preview">
      <div>
        <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-orange-50 text-orange-700
                        text-[11px] font-semibold uppercase tracking-[0.14em] border border-orange-200">
          Maqueta · datos de ejemplo
        </div>
        <h1 className="font-display text-4xl font-extrabold tracking-[-0.03em] mt-3">Efectividad de leads</h1>
        <p className="text-slate-500 mt-1">Cuatro propuestas. Dígame cuáles quiere y las conecto con los datos reales.</p>
      </div>

      <section className="space-y-3">
        <Etiqueta>Opción A · tarjeta compacta para el Resumen</Etiqueta>
        <div className="max-w-sm"><OpcionA /></div>
      </section>

      <section className="space-y-3">
        <Etiqueta>Opción B · embudo con cuello de botella</Etiqueta>
        <div className="max-w-2xl"><OpcionB /></div>
      </section>

      <section className="space-y-3">
        <Etiqueta>Opción C · la clase introductoria como predictor</Etiqueta>
        <div className="max-w-md"><OpcionC /></div>
      </section>

      <section className="space-y-3">
        <Etiqueta>Opción D · canal, dinero y motivos de pérdida</Etiqueta>
        <OpcionD />
      </section>
    </div>
  );
}
